import { httpClient } from "../../../shared/api/httpClient";
import type { PaginatedResponse } from "../../../shared/api/pagination";
import type { CustomerResponse } from "../model/types";

export interface CustomerListQuery {
  page?: number;
  page_size?: number;
  search?: string;
  company_name?: string;
  sort_by?: string;
  sort_dir?: string;
}

export const fetchCustomers = async (
  page = 1,
  pageSize = 100,
): Promise<PaginatedResponse<CustomerResponse>> => {
  const response = await httpClient.get<PaginatedResponse<CustomerResponse>>(
    "/customers",
    {
      params: { page, page_size: pageSize },
    },
  );
  return response.data;
};

export const searchCustomers = async (
  search: string,
  _activeOnly = true,
  page = 1,
  pageSize = 100,
): Promise<PaginatedResponse<CustomerResponse>> => {
  const response = await httpClient.get<PaginatedResponse<CustomerResponse>>(
    "/customers",
    {
      params: { search, page, page_size: pageSize },
    },
  );
  return response.data;
};

export const searchCustomersByCompanyName = async (
  companyName: string,
  _activeOnly = true,
  page = 1,
  pageSize = 100,
): Promise<PaginatedResponse<CustomerResponse>> => {
  const response = await httpClient.get<PaginatedResponse<CustomerResponse>>(
    "/customers",
    {
      params: {
        company_name: companyName,
        page,
        page_size: pageSize,
        sort_by: "company_out_name",
        sort_dir: "asc",
      },
    },
  );
  return response.data;
};

export const fetchCustomerByCodes = async (
  mtCode: string,
  branchCode = "",
): Promise<CustomerResponse> => {
  const response = await httpClient.get<CustomerResponse>(
    `/customers/${encodeURIComponent(mtCode)}`,
    { params: branchCode ? { branch_code: branchCode } : undefined },
  );
  return response.data;
};
